export default "__VITE_ASSET__C9aQR1f0__"